<template>
  <div class="task-display">
    <button
      type="button"
      v-on:click.self="$emit('close')"
      class="task-display__overlay"
    />
    <div class="task-display__content">
      <article class="task-display__left">
        <section class="task-display__left__header">
          <p class="task-display__caption">{{ task.title }}</p>
          <p v-if="task.description" class="task-display__description">{{ task.description }}</p>
        </section>
        <task-chat
          class="task-display__left__chat"
          v-bind:task="task"
          v-bind:input-errors="violations"
          v-on:submit="submitComment"
        />
      </article>
      <div class="task-display__right">
        <button type="button" class="task-display__exit" v-on:click="$emit('close')" />
        <div class="task-display__container">
          <div class="task-display__term">
            <span>Дата создания:</span>
            <div>{{ task.createdAt }}</div>
          </div>
          <div class="task-display__term">
            <span>Дедлайн: </span>
            <div class="overdue">
              {{ task.deadLineInFormat }}
            </div>
          </div>
          <div
            class="task-display__status"
            v-bind:class="`status-${task.status}`"
          >
            {{ mapStatus(task.status) }}
          </div>
          <div class="task-display__term">
            <span>Автор:</span>
            <div>{{ task.authorName }}</div>
          </div>
          <div class="task-display__term">
            <span>Исполнитель:</span>
            <div>{{ task.performerName }}</div>
          </div>
          <div v-if="task.patientId" class="task-display__term">
            <span>Пациент:</span>
            <router-link v-bind:to="{ name: 'ClinicPanelPatientAppointments', params: { id: task.patientId } }">
              {{ task.patientName }}
            </router-link>
          </div>
        </div>
        <div class="task-display__buttons">
          <div class="task-display__buttons__row">
            <button
              type="button"
              v-on:click="editTask"
              class="task-display__button-edit"
            >
              Редактировать
            </button>
            <button
              type="button"
              v-on:click="deleteDialog = true"
              class="task-display__button-remove"
            />
          </div>
          <button
            type="button"
            v-on:click="finishTask"
            class="task-display__button-finish"
          >
            Завершить задачу
          </button>
        </div>
      </div>
    </div>
    <modal-dialog
      v-model="deleteDialog"
      title="Вы точно хотите удалить задачу?"
      with-cross
    >
      <div class="task-display__modal__buttons">
        <button
          class="modal-button"
          type="button"
          v-on:click="deleteDialog = false">Нет</button>
        <button
          class="modal-button negative"
          type="button"
          v-on:click="removeTask">Да, удалить</button>
      </div>
    </modal-dialog>
  </div>
</template>

<script>
import { TaskForEdit, mapStatus } from '@/storage/gateways/TaskGateway';
import ModalDialog from '@/components/ModalDialog.vue';
import TaskChat from '@/components/TaskChat.vue';

export default {
  name: 'TaskDisplay',
  components: { TaskChat, ModalDialog },
  data() {
    return {
      /** Состояние диалога для удаления */
      deleteDialog: false,
    };
  },
  props: {
    task: { type: TaskForEdit, required: true },
    violations: { type: Object, default: () => {} },
  },
  methods: {
    mapStatus,
    finishTask() {
      this.$emit('complete-task', this.task.id);
    },
    editTask() {
      this.$emit('edit-task', this.task.id);
    },
    removeTask() {
      this.deleteDialog = false;
      this.$emit('delete-task', this.task.id);
    },
    submitComment(comment) {
      this.$emit('submit-comment', this.task.id, comment);
    },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.modal-button {
  width: 100%;
  height: 2rem;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid #0489E0;
  background-color: #FFFFFF;
  color: #0489E0;
  transition: all 0.3s ease 0s;
  cursor: pointer;
  outline: none;
  max-width: 50%;
  margin: 0 5px;
}
.negative {
  border: 1px solid rgba(224, 4, 4, 0.97);
  color: rgba(224, 4, 4, 0.97);
}
.task-display {
  &__overlay {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: #00000073;
    cursor: default;
  }
  &__content {
    display: grid;
    grid-template-columns: 1fr 323px;
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    max-width: 1100px;
    background-color: #FFFFFF;
    box-shadow: -6px 0px 18px rgba(0, 0, 0, 0.06);
    z-index: 5;
    clip-path: inset(0px 0px 0px -15px);
    overflow: auto;
  }
  &__left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    padding: 38px 22px 20px 30px;
    &__header {
      display: grid;
      row-gap: 15px;
      width: 100%;
      max-height: 25dvh;
      margin-bottom: 30px;
    }
  }
  &__caption {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #192A3E;
    text-align: left;
    overflow-wrap: anywhere;
    overflow: hidden;
  }
  &__description {
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    color: #323C47;
    text-align: left;
    white-space: break-spaces;
    overflow-y: auto;
  }
  &__right {
    display: flex;
    flex-direction: column;
    gap: 20px;
    background: #EAEFF3;
    padding: 60px 25px;
    height: 100%;
  }
  &__exit {
    background-image: url("@/assets/img/exit-black.svg");
    width: 20px;
    height: 20px;
    position: absolute;
    right: 10px;
    top: 20px;
  }
  &__container {
    display: flex;
    flex-direction: column;
    gap: 18px;
    background: #FFFFFF;
    border-radius: 4px;
    padding: 18px 18px 30px 18px;
  }
  &__term {
    display: grid;
    grid-template-columns: 110px 1fr;
    grid-gap: 12px;
    align-items: center;
    justify-items: left;
    border-bottom: 1px solid #EAEFF3;
    padding: 0 0 19px 0;
    font-size: 16px;
    line-height: 19px;
    color: #192A3E;
    span {
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: #707683;
    }
    .overdue {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #EF474C;
    }
  }
  &__status {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #323C47;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    background: #F3FFE4;
    border-radius: 4px;
    padding: 16px;
    &.status-new {
      background-color: #FFFFFF;
      padding: 16px 16px 16px 0;
    }
    &.status-work {
      background-color: #F3FFE4;
    }
    &.status-completed {
      background-color: #E4FFEC;
    }
    &.status-canceled {
      background-color: #FFECEC;
    }
    &:before {
      content:'';
      height: 20px;
      margin-right: 10px;
      width: 20px;
    }
    &.status-new:before {
      background-color: #abb1a3;
      border-radius: 50%;
      content: "";
      height: 6px;
      width: 6px;
      margin-right: 10px;
    }
    &.status-work:before {
      background-image: url("@/assets/img/status/cheked-green.svg");
      background-repeat: no-repeat;
      background-size: contain;
      height: 15px;
      width: 15px;
    }
    &.status-completed:before {
      background-image: url("@/assets/img/checked/all-checked-green.svg");
      background-repeat: no-repeat;
      background-size: contain;
    }
    &.status-canceled:before {
      background-image: url("@/assets/img/exit-red.svg");
      min-width: 20px;
      min-height: 20px;
    }
  }
  &__employee {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #0489E0;
    &__label {
      display: flex;
      width: 100%;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: #707683;
      border-bottom: 1px solid #EAEFF3;
      padding: 0 0 6px 0;
      margin: 0 0 10px 0;
    }
    &__row {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
  &__buttons {
    display: flex;
    flex-direction: column;
    gap: 23px;
    &__row {
      display: grid;
      grid-template-columns: 1fr 48px;
      grid-gap: 10px;
    }
  }
  &__button {
    &-edit {
      @include buttons.btn-transparent(100%, 48px, 16px);
      background-color: transparent;
      &:before {
        content: '';
        background-image: url("@/assets/img/pen-blue.svg");
        background-repeat: no-repeat;
        width: 17px;
        height: 17px;
        margin: 0 10px 0 0;
      }
    }
    &-remove {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;
      border: 1px solid #0489E0;
      border-radius: 4px;
      background-image: url("@/assets/img/remove-blue.svg");
      background-position: center;
      &:hover {
        border: 1px solid #0076C3;
      }
    }
    &-finish {
      @include buttons.btn-blue(100%, 48px, 16px);
    }
  }
  &__modal {
    &__buttons {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin: 20px 0 0 0;
    }
  }
}
@media screen and (max-width: 620px) {
  .task-display {
    &__content {
      grid-template-columns: 1fr;
      align-content: start;
    }
  }
}
@media screen and (max-width: 480px) {
  .task-display {
    &__left {
      height: 100dvh;
      padding: 38px 15px;
    }
    &__right {
      padding: 38px 5px;
    }
    &__caption {
      -webkit-line-clamp: 3;
    }
    &__buttons {
      padding: 0 15px;
    }
  }
}
@media screen and (max-width: 380px) {
  .task-display {
    &__left {
      &__header {
        grid-template-rows: 85px;
      }
    }
  }
}
</style>
